const CURRENCY_CODES = {
  US: 'USD',
  BB: 'USD',
  KY: 'USD',
  CA: 'CAD',
  AU: 'AUD',
  GB: 'GBP',
  NZ: 'NZD',
}

export function getCurrencyForCountry(country) {
  return CURRENCY_CODES[country] || 'USD'
}

export function getPriceForCountry(currencies, country) {
  const code = getCurrencyForCountry(country)
  return Number(currencies?.find(c => c.currency === code)?.unitAmount ?? 0)
}
